export interface TwoPlusTwoCoaching {
    cycleParticipantId: number;
    creationUserId: string;
    subjectUserId: string;
    field1?: string;
    field1Comment?: string;
    field2?: string;
    field2Comment?: string;
    field3?: string;
    field3Comment?: string;
    field4?: string;
    field4Comment?: string;
    field5?: string;
    field5Comment?: string;
    field6?: string;
    field6Comment?: string;
    field7?: string;
    field7Comment?: string;
    field8?: string;
    field8Comment?: string;
    field9?: string;
    field9Comment?: string;
    field10?: string;
    field10Comment?: string;
    field11?: string;
    field11Comment?: string;
    field12?: string;
    field12Comment?: string;
    field13?: string;
    field13Comment?: string;
    field14?: string;
    field14Comment?: string;
    field15?: string;
    field15Comment?: string;
    field16?: string;
    field16Comment?: string;
    field17?: string;
    field17Comment?: string;
    field18?: string;
    field18Comment?: string;
    field19?: string;
    field19Comment?: string;
    field20?: string;
    field20Comment?: string;

    managerComment?: string;
    generalComments?: string;
    status: TwoPlusTwoCoachingStatus;
    authorizationDate?: Date;
}

export enum TwoPlusTwoCoachingStatus {
    Draft = 0,
    AwaitingAuthorization = 1,
    Authorized = 2
}
